import { Action } from '@canvas/model/permissions';

import { policyAction, type PersistentPolicy } from '../../policy-manager-types.ts';

export const canWritePolicy: PersistentPolicy = {
  id: 'can-write',
  type: 'persistent',
  rule: (state) => {
    const action = policyAction(Action.write);
    if (state.has(action)) {
      return { can: action };
    }
    return { cannot: action };
  },
};
